<template>
    <div class="flip-card">
        <div class="card-inner" :class="{ flipped: isFlipped }">
            <!-- Front -->
            <div class="card front">
                <div style="display: flex; flex-direction: column; gap: 10px;">
                    <!-- <div style="display: flex; align-items: start; width: 100%;">
                        <img :src="info.icon"
                            style="width: 30px; height: 30px; margin-right: 10px;" />
                        <el-tag :class="info.category+'-tag'" size="large" style="font-size: 16px; width: fit-content;"> {{ info.name}} </el-tag>
                    </div> -->
                    <div class="card-title"
                        :style="{ backgroundColor: info.color }">
                        {{ info.name}}
                    </div>
                    <div style="padding: 0 20px;">
                        {{ info.description }}
                    </div>
                </div>
                <div style="display: flex; flex-direction: column; gap: 20px;">
                    <img :src="info.icon"
                    style="width: 200px; height: 200px;" />
                    <!-- <el-image
                        :src="imageUrl(info.examples[0].name, 1)"
                        :preview-src-list="[imageUrl(info.examples[0].name)]"
                        style="height: 200px; width: 200px"
                        fit="cover"
                    >
                        <div slot="placeholder" class="image-slot">
                        <i class="el-icon-loading"></i>
                        Loading<span class="dot">...</span>
                        </div>
                        <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image> -->
                    <button class="flip-button" @click="flip">Show more examples</button>
                </div>
            </div>
            <!-- Back -->
            <div class="card back">
                <!-- <div style="display: flex; align-items: start; width: 100%;">
                    <img 
                        :src="info.icon"
                        style="width: 30px; height: 30px; margin-right: 10px;" />
                    <el-tag :class="info.category+'-tag'" size="large" style="font-size: 16px; width: fit-content;"> {{ info.name}} </el-tag>
                </div> -->
                
                <div class="card-title"
                    :style="{ backgroundColor: info.color }">
                    {{ info.name}}
                </div>
                <el-carousel trigger="click" height="290px" :autoplay="false" style="width: 100%;" indicator-position="outside">
                    <el-carousel-item v-for="(item, index) in info.examples" :key="index" style="height: 100%;">
                        <div style="display: flex; flex-direction: column; padding: 10px 30px; gap: 10px;">
                            <el-image
                                :src="imageUrl(item.name, 1)"
                                :preview-src-list="[imageUrl(item.name)]"
                                style="height: 210px; width: 100%; align-self: center;"
                                fit="cover"
                            >
                                <div slot="placeholder" class="image-slot">
                                <i class="el-icon-loading"></i>
                                Loading<span class="dot">...</span>
                                </div>
                                <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                            <div style="overflow-y: scroll; height: 60px;">
                                {{ item.description }}
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
                <button class="flip-button back-button" @click="unflip">Back to definition</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'FlipCard',
  props: {
    width: {
      type: String,
      default: '300px'
    },
    height: {
      type: String,
      default: '450px'
    },
    info: {
        type: Object,
        default: () => ({})
    },
  },
  data() {
    return {
      isFlipped: false
    };
  },
  methods: {
    flip() {
      this.isFlipped = true;
    },
    unflip() {
      this.isFlipped = false;
    },
    imageUrl(name, thumb=0) {
        return '/api/image?name=' + name + (thumb ? '&thumb=1' : '');
    },
  }
};
</script>

<style scoped>
.flip-card {
  perspective: 1000px;
  width: v-bind(width);
  height: v-bind(height);
  position: relative;
  margin: 5px 15px;
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
  box-shadow: 12px 12px 36px 0px rgba(151, 170, 191, 0.38);
  border-radius: 10px;
  display: inline-block;
}

.card-title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 5px;
    display: flex; 
    align-items: center; 
    justify-content: center;  
    width: 100%; 
    color: white;
    border-radius: 10px 10px 0 0;
    padding: 15px 0;
}

.card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.card-inner.flipped {
  transform: rotateY(180deg);
}

.card {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 10px;
  padding: 0px;
  padding-bottom: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: white;
  align-items: center;
}

.front {
  z-index: 2;
  background-color: #ffffff;
}

.back {
  transform: rotateY(180deg);
  /* background-color: #f7f7f7; */
}

.flip-button {
  padding: 8px 16px;
  /* background-color: #0a3d62; */
  background-color: #444;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
  align-self: center;
  transition: background-color 0.3s;
  width: 200px;
}

.flip-button:hover {
  /* background-color: #1e88e5; */
  background-color: #000000;
}

.back-button {
  background-color: #444;
}

.back-button:hover {
  background-color: #000;
}
</style>
